import { getAvatar } from "../../utils/avatar";
import { useVideoContext, VideoStatusEnum } from "../../stores/video";
import {Replay} from "@mui/icons-material";

type TProps = {
  src: string;
  filename: string;
  type: string;
};
const ChatFileCard = (props: TProps) => {
  const { play, status } = useVideoContext();

  const handleClick = async (id: string) => {
    if (!id) return;
    const result = await getAvatar(id);
    const video = result.outputs.result;
    const link = document.createElement("a");
    link.href = video;
    link.click();
  };

  const handleClickReplay = async (id: string) => {
    if (!id) return;
    const result = await getAvatar(id);
    const video = result.outputs.result;
    play && play(video);
  };

  const disabledReplay = status === VideoStatusEnum.loadstart;

  return (
    <div className="flex items-center">
      <button
        onClick={() => handleClick(props.src)}
        className="border border-gray-300 p-2 rounded flex hover:bg-gray-100"
      >
        <div className="flex items-center">
          <img
            src={process.env.PUBLIC_URL + "/images/youtube.png"}
            alt=""
            width={24}
            height={24}
            className="mr-2"
          />
          <span className="font-bold text-sm">{props.filename}</span>
        </div>
      </button>
      <button
        onClick={() => handleClickReplay(props.src)}
        className={`transition-colors duration-200 w-[24px] h-[24px] rounded-full ml-1 ${
          disabledReplay || "hover:bg-gray-300"
        } flex justify-center items-center text-gray-500`}
        disabled={disabledReplay}
      >
        <Replay fontSize="small"/>
      </button>
    </div>
  );
};

export default ChatFileCard;
